import { queryClient } from 'react-query-client';
import { USER_PERMISSION_QUERY_KEY } from 'app/constants';
import { DashboardAccessAndPermission, Permissions } from 'app/types/permission';

export const hasUserAccessRights = (accessRight: Permissions): boolean => {
  const { permissions } = queryClient.getQueryData(USER_PERMISSION_QUERY_KEY) as DashboardAccessAndPermission;
  return permissions.includes(accessRight);
};
